module.exports = __webpack_public_path__ + "img/申请证书_外框.414d86a4.png";